import ContactsMain from 'components/featured/Contacts';
import React from 'react';

const Contacts = () => {
  return (
    <>
      <ContactsMain />
    </>
  );
};

export default Contacts;
